module.exports = __webpack_public_path__ + "static/media/blog-posts.084ce37e.png";